<div>
  <h1>{{ dataFromArticle }}</h1>
</div>
